import { createContext, useContext } from "react";
import { translations } from "./i18n";

export const LangContext = createContext({ lang: "en", setLang: () => {}, t: translations.en });
export const useLang = () => useContext(LangContext);
